import { InputNumberLocalized } from '@components'

import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useCustomerForm } from '../../../../contexts/customerFormContext'

export const CustomerNumber = (): ReactElement => {
  const { t } = useTranslation()
  const { customerForm } = useCustomerForm()
  const { FormItem } = customerForm

  return (
    <FormItem
      itemColumnEnd={11}
      itemColumnStart={1}
      name="customerNumber"
      label={t('customer_modal.form.customer_number.label')}
      render={({ field }) => {
        return (
          <InputNumberLocalized
            {...field}
            alignment="left"
            autoFocus
            isFallbackToZero={false}
            size="sm"
            withCalculations={false}
            withFormatting={false}
          />
        )
      }}
    />
  )
}
